import axios from "axios";
import { useEffect, useState } from "react";
import { states } from "../Common/states";
import { countries } from "./countries";
import { ukcounties } from "./ukcounties";
import "./style.css";
import {
  CitySelect,
  CountrySelect,
  StateSelect,
  LanguageSelect,
  RegionSelect,
  PhonecodeSelect,
} from "react-country-state-city";
import "react-country-state-city/dist/react-country-state-city.css";

const Field = ({ id, label, required, error, textarea, children, ...inputProps }) => (
  <div
    className={`hangar-field${required ? " hangar-field--required" : ""}${
      error ? " hangar-field--error" : ""
    }`}
  >
    <label htmlFor={id}>{label}</label>
    {children ||
      (textarea ? (
        <textarea id={id} rows={3} aria-invalid={!!error} {...inputProps} />
      ) : (
        <input id={id} aria-invalid={!!error} {...inputProps} />
      ))}
  </div>
);

const HangarInfo = (props) => {
  const [isModal, setModal] = useState(false);
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");
  const [country, setCountry] = useState(null);
  const [theState, setTheState] = useState(null);
  const [city, setCity] = useState(null);
  const [language, setLanguage] = useState(null);
  const [isMobile, setMobile] = useState(false);
  const [errorFields, setErrorFields] = useState({
    firstName: false,
    lastName: false,
    email: false,
    phone: false,
    userType: false,
    address1: false,
    city: false,
    state: false,
    zipCode: false,
    country: false,
    password: false,
    language: false,
  });
  const [contactObj, setContactObj] = useState({
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    userType: "",
    theaterName: "",
    owningCircuit: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    zipCode: "",
    country: "",
    message: "",
    password: "",
    language: "",
  });

  useEffect(() => {
    console.log(contactObj);
  }, [contactObj]);

  useEffect(() => {
    console.log(country);
  }, [country]);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const countryParam = params.get("country");
    console.log("User param:", countryParam);
    if (countryParam) {
      // find country param in countries list
      const foundCountry = countries.filter(
        (x) => x.iso2 === countryParam.toUpperCase()
      );
      if (foundCountry.length) {
        // country exists, select it for the user
        setCountry(foundCountry[0]);
        handleChangeDropdown("country", foundCountry[0].name);
      }
    }
  }, []);

  useEffect(() => {
    handleResizeEvent();
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResizeEvent);
    return () => {
      window.removeEventListener("resize", handleResizeEvent);
    };
  }, []);

  useEffect(() => {
    document.body.classList.add("no-scroll");
  }, []);

  const handleResizeEvent = () => {
    if (window.innerWidth < 500) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  };

  const handleChangeFieldString = (e) => {
    setError("");
    let key = e.target.id;
    let value = e.target.value;
    let errors = { ...errorFields };
    Object.assign(errors, { [key]: false });
    setErrorFields(errors);
    let obj = { ...contactObj };
    Object.assign(obj, { [key]: value });
    setContactObj(obj);
  };

  const handleChangeDropdown = (key, value) => {
    setError("");
    let errors = { ...errorFields };
    Object.assign(errors, { [key]: false });
    setErrorFields(errors);
    let obj = { ...contactObj };
    Object.assign(obj, { [key]: value });
    if (key === "country") {
      Object.assign(obj, { state: "", city: "", zipCode: "" });
      setTheState(null);
      setCity(null);
    }
    if (key === "state") {
      Object.assign(obj, { city: "", zipCode: "" });
      setCity(null);
    }
    if (key === "city") {
      Object.assign(obj, { zipCode: "" });
    }
    setContactObj(obj);
  };

  const handleSend = async () => {
    setSending(true);
    //validate data first
    const errors = { ...errorFields };
    if (!contactObj.firstName) {
      Object.assign(errors, { firstName: true });
    }
    if (!contactObj.lastName) {
      Object.assign(errors, { lastName: true });
    }
    if (!contactObj.email) {
      Object.assign(errors, { email: true });
    }
    if (!contactObj.phone) {
      Object.assign(errors, { phone: true });
    }
    if (!contactObj.userType) {
      Object.assign(errors, { userType: true });
    }
    if (!contactObj.address1) {
      Object.assign(errors, { address1: true });
    }
    if (!contactObj.country) {
      Object.assign(errors, { country: true });
    }
    if (!contactObj.language) {
      Object.assign(errors, { language: true });
    }
    setErrorFields(errors);
    if (errors.firstName || errors.lastName || errors.email) {
      setSending(false);
      return;
    }
    try {
      const { data } = await axios.post(
        "https://tower.paperairmedia.com/api/infoRequest",
        {
          firstName: contactObj.firstName,
          lastName: contactObj.lastName,
          email: contactObj.email,
          phone: contactObj.phone,
          userType: contactObj.userType,
          theaterName: contactObj.theaterName,
          owningCircuit: contactObj.owningCircuit,
          address1: contactObj.address1,
          address2: contactObj.address2,
          city: contactObj.city,
          state: contactObj.state,
          zipCode: contactObj.zipCode,
          country: contactObj.country,
          message: contactObj.message,
          password: contactObj.password,
          language: contactObj.language,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (data && data.message === "Sent") {
        setSuccess(true);
        setSending(false);
        setModal(true);
      } else {
        // something went wrong, eventually need more error handling than this
        setSending(false);
        setError("Error processing request.");
      }
    } catch (error) {
      console.log(error);
      setSending(false);
      setError(error.message);
    }
  };

  const handleDismiss = () => {
    setSuccess(false);
    setModal(false);
    setContactObj({
      firstName: "",
      lastName: "",
      phone: "",
      email: "",
      userType: "",
      theaterName: "",
      owningCircuit: "",
      address1: "",
      address2: "",
      city: "",
      state: "",
      zipCode: "",
      country: "",
      message: "",
      password: "",
      language: "",
    });
    setError("");
  };

  return (
    <div
      className="animate__animated animate__fadeIn animate__slower"
      id="home-container"
    >
      <div
        style={{
          width: "100%",
          height: "calc(100vh)",
          display: "flex",
          justifyContent: "center",
          flexWrap: "wrap",
          alignItems: "center",
          backgroundImage: "url(./images/home-hero-1.jpg)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          overflow: "hidden",
        }}
        className="wrap-section"
      >
        <div
          style={{
            position: "absolute",
            top: "10px",
            left: "10px",
            width: "150px",
            cursor: "pointer",
          }}
          onClick={() => (window.location.href = "/")}
        >
          <img
            className="hangar-logo"
            src="/images/logo-white.png"
            alt="PaperAirplane"
          />
        </div>
        <div
          className="mobile-scroll"
          style={{
            backgroundColor: "#F1F1F1",
            padding: "20px",
            borderRadius: isMobile ? "" : "20px",
            height: isMobile ? "100dvh" : "90dvh",
            overflow: "auto",
            zIndex: 1,
            width: "100%",
            maxWidth: "700px",
            position: isMobile ? "absolute" : "",
            top: isMobile ? "0px" : "",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <span
              style={{
                fontSize: 20,
                fontWeight: 800,
                color: "#676767",
                margin: "5px",
              }}
            >
              The Hangar Global
            </span>
            <span
              style={{
                fontSize: 28,
                fontWeight: 900,
                color: "#000000",
                margin: "5px",
                fontStyle: "oblique",
              }}
            >
              Departure Lounge
            </span>
            <span
              style={{
                fontSize: 16,
                fontWeight: 800,
                color: "#676767",
                margin: "5px",
              }}
            >
              Information Request
            </span>
          </div>
          {/* Enter does nothing here; the form sends from the Submit button. */}
          <form className="hangar-form" onSubmit={(e) => e.preventDefault()} noValidate>
            <div className="hangar-row">
              <Field
                error={errorFields.firstName}
                required
                id="firstName"
                label="First Name"
                value={contactObj.firstName}
                placeholder="First Name"
                onChange={handleChangeFieldString}
              />
              <Field
                error={errorFields.lastName}
                required
                id="lastName"
                label="Last Name"
                value={contactObj.lastName}
                placeholder="Last Name"
                onChange={handleChangeFieldString}
              />
            </div>
            <div className="hangar-row">
              <Field
                error={errorFields.phone}
                required
                id="phone"
                label="Phone"
                value={contactObj.phone}
                placeholder="Phone"
                onChange={handleChangeFieldString}
              />
              <Field
                error={errorFields.email}
                required
                id="email"
                label="Email"
                value={contactObj.email}
                placeholder="Email"
                onChange={handleChangeFieldString}
              />
            </div>
            <Field
              error={errorFields.userType}
              required
              id="userType"
              label="User Type"
            >
              <select
                id="userType"
                value={contactObj.userType}
                onChange={handleChangeFieldString}
                className={contactObj.userType ? "" : "hangar-select--empty"}
              >
                <option value="" disabled>
                  Select type...
                </option>
                <option value="Booking Agent">Booking Agent</option>
                <option value="Circuit Head Office">Circuit Head Office</option>
                <option value="Cinema">Cinema</option>
                <option value="Other">Other</option>
              </select>
            </Field>
            <div className="hangar-row">
              <Field
                error={errorFields.theaterName}
                id="theaterName"
                label="Cinema Name"
                value={contactObj.theaterName}
                placeholder="e.g. Cineworld London Leicester Square"
                onChange={handleChangeFieldString}
              />
              <Field
                error={errorFields.owningCircuit}
                id="owningCircuit"
                label="Owning Circuit"
                value={contactObj.owningCircuit}
                placeholder="e.g.  Cineworld, Odeon, Vue, Showcase, etc…"
                onChange={handleChangeFieldString}
              />
            </div>
            <div className="hangar-row">
              <Field
                required
                error={errorFields.address1}
                id="address1"
                label="Street Address"
                value={contactObj.address1}
                placeholder="Theater or circuit address"
                onChange={handleChangeFieldString}
              />
              <Field
                id="address2"
                label="Suite/Apt#"
                value={contactObj.address2}
                placeholder="Suite 101"
                onChange={handleChangeFieldString}
              />
            </div>
            <hr className="hangar-divider" />
            <Field required label="Language">
              <LanguageSelect
                src="/min/"
                error={errorFields.language}
                containerClassName="form-group"
                onChange={(lang) => {
                  setLanguage(lang);
                  handleChangeDropdown("language", lang.name);
                }}
                defaultValue={language}
                placeHolder="Select Language"
              />
            </Field>
            <Field required label="Country">
              <CountrySelect
                defaultValue={country?.id}
                src="/min/"
                error={errorFields.country}
                placeHolder="Select Country"
                onChange={(country) => {
                  setCountry(country);
                  handleChangeDropdown("country", country.name);
                }}
              />
            </Field>

            {country?.id !== 232 && (
              <Field required label={country?.id === 232 ? "County" : "State"}>
                <StateSelect
                  error={errorFields.state}
                  disabled={!country?.id}
                  countryid={country?.id}
                  onChange={(state) => {
                    setTheState(state);
                    handleChangeDropdown("state", state.name);
                  }}
                  defaultValue={theState}
                  placeHolder={
                    country?.id === 232 ? "Select County" : "Select State"
                  }
                />
              </Field>
            )}

            {country?.id === 232 && (
              <Field required id="state" label="County/City">
                <select
                  id="state"
                  value={contactObj.state}
                  onChange={handleChangeFieldString}
                  className={contactObj.state ? "" : "hangar-select--empty"}
                >
                  <option value="" disabled>
                    County/City
                  </option>
                  {ukcounties.map((group) => (
                    <optgroup key={group.region} label={group.region}>
                      {group.counties.map((county) => (
                        <option key={county} value={county}>
                          {county}
                        </option>
                      ))}
                    </optgroup>
                  ))}
                </select>
              </Field>
            )}

            {country?.id !== 232 && theState?.hasCities && (
              <Field required label="City">
                <CitySelect
                  error={errorFields.city}
                  placeHolder="Select City"
                  countryid={country?.id}
                  stateid={theState?.id}
                  disabled={!theState?.id}
                  onChange={(city) => {
                    setCity(city);
                    handleChangeDropdown("city", city.name);
                  }}
                  defaultValue={city}
                />
              </Field>
            )}

            <Field
              required
              error={errorFields.zipCode}
              id="zipCode"
              label="Zip / Postal Code"
              value={contactObj.zipCode}
              placeholder="Zip Code"
              onChange={handleChangeFieldString}
            />
            <hr className="hangar-divider" />
            <Field
              textarea
              error={errorFields.message}
              id="message"
              label="Message"
              value={contactObj.message}
              placeholder="Enter your message..."
              onChange={handleChangeFieldString}
            />
            {(errorFields.firstName ||
              errorFields.lastName ||
              errorFields.email ||
              errorFields.message) && (
              <p className="hangar-message hangar-message--error">
                Please fill out all required fields.
              </p>
            )}
            {error && (
              <p className="hangar-message hangar-message--error">{error}</p>
            )}
            {success && (
              <p className="hangar-message hangar-message--success">
                Request Sent Successfully!
              </p>
            )}
            <button
              type="button"
              className={`hangar-submit${sending ? " hangar-submit--loading" : ""}`}
              disabled={sending || success}
              onClick={handleSend}
            >
              Submit
            </button>
          </form>
        </div>
      </div>
      {success && isModal && (
        <div className="hangar-overlay">
          <div className="hangar-success" role="dialog" aria-modal="true">
            Thank you! Your message has been sent to the PaperAirplane team.
            <button
              type="button"
              className="hangar-success-close"
              aria-label="Close"
              onClick={handleDismiss}
            >
              <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                <path
                  d="M6 6l12 12M18 6L6 18"
                  stroke="currentColor"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                />
              </svg>
            </button>
          </div>
        </div>
      )}
    </div>
    // <Modal open size="small">
    //   <Modal.Header style={{ backgroundColor: "#4682CC" }}>
    //     <Header inverted>
    //       Contact Us
    //       <Header.Subheader>
    //         Please fill out the form below to inquire about a collaboration, or
    //         simply say hello.
    //       </Header.Subheader>
    //     </Header>
    //   </Modal.Header>
    //   <Modal.Content style={{ backgroundColor: "#F1F1F1" }}>

    //   </Modal.Content>
    //   <Modal.Actions
    //     style={{ display: "flex", justifyContent: "space-between" }}
    //   >
    //     <Button size="large" content="Cancel" onClick={() => setModal(false)} />
    //     <Button
    //       size="large"
    //       primary
    //       content="Send"
    //       onClick={handleSend}
    //       loading={sending}
    //       disabled={sending}
    //     />
    //   </Modal.Actions>
    //   {success && (
    //     <Modal open size="tiny">
    //       <Message
    //         positive
    //         content="Thank you! Your message has been sent to the PaperAirplane team."
    //         onDismiss={handleDismiss}
    //       />
    //     </Modal>
    //   )}
    // </Modal>
  );
};
export default HangarInfo;
